import React from 'react';
import css from './LayoutAdmin.module.scss';
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import  axios  from '../../../Axios/Default';

const LayoutAdmin = () => {
    const access_token_admin = localStorage.getItem("access_token_admin");
    axios.defaults.headers.common["Authorization"] = `Bearer ${access_token_admin}`;
    
    let navigate = useNavigate();

    const location = useLocation();
    const [state, setNewState] = useState({ 
        title_dashboard : '', });

    const setState = data => {
        setNewState(prevState => ({ ...prevState, ...data }));
    }


    useEffect(() => {
        setState({title_dashboard:location.pathname})
        if(!access_token_admin){
            navigate('/admin/login');
        }
    }, [location]); 

    
  const handleLogout = () => {
    // alert('asdas')
    localStorage.clear();
    sessionStorage.clear();
    navigate('/admin/login'); 
    
  };

    const { title_dashboard } = state;
    
    function handleBack() {
        navigate(-1);
    }

    return (
        <div className='wrap_admin'>
            <div className='row vh-100'>
                <div className='col-md-2 text-center' style={{ background: '#fff', borderRight:'1px solid #D9D9D9' }}>
                    <img src='/monitoring/MonitoringAssets/Logo.png' className={css.logo} />
                    <div className={css.menu}>
                        <ul>
                            <NavLink to="/admin/dashboard" className={css.menu_bar_item}>
                                {({ isActive }) => (
                                    <>
                                        <li className={isActive && css.active}><label>Dashboard</label></li>
                                    </>
                                )}
                            </NavLink>
                            <NavLink to="/admin/list-plts" className={css.menu_bar_item}>
                                {({ isActive }) => (
                                    <>
                                        <li className={isActive && css.active}><label>List PLTS</label></li>
                                    </>
                                )}
                            </NavLink>
                            <NavLink to="/admin/list-user" className={css.menu_bar_item}>
                                {({ isActive }) => (
                                    <>
                                        <li className={isActive && css.active}><label>User PLTS</label></li>
                                    </>
                                )}
                            </NavLink>
                            <NavLink to="/admin/mapping-list" className={css.menu_bar_item}>
                                {({ isActive }) => (
                                    <>
                                        <li className={isActive && css.active}><label>Mapping List</label></li>
                                    </>
                                )}
                            </NavLink>
                            <NavLink to="/admin/list-admin" className={css.menu_bar_item}>
                                {({ isActive }) => (
                                    <>
                                        <li className={isActive && css.active}><label>List Admin</label></li>
                                    </>
                                )}
                            </NavLink>
                            <div className={css.menu_bar_item}  onClick={handleLogout}>
                                {/* {({ isActive }) => ( */}
                                    <>
                                        <li><label>Logout</label></li>
                                    </>
                                {/* )} */}
                            </div>
                        </ul>
                    </div>
                </div>
                <div className='col-md-10' style={{ maxHeight: '100vh'}}>
                    <div className={css.header}>
                        <div className='row'>
                            <div className={`${css.title} col-md-9`}>
                                <h2>
                                {title_dashboard == '/admin/dashboard' && 'Dashboard'}
                                {title_dashboard == '/admin/list-admin' && 'List Admin'}
                                {title_dashboard == '/admin/list-admin/add-admin' && 
                                    <div onClick={()=>handleBack()} style={{cursor:'pointer'}}>
                                        <i class="fi fi-rr-angle-small-left"></i> Create Admin
                                    </div>
                                }
                                    
                                {title_dashboard.replace(/\/[A-Za-z0-9+/=]+$/, "") == '/admin/list-admin/edit-admin' && 
                                    <div onClick={()=>handleBack()} style={{cursor:'pointer'}}>
                                        <i class="fi fi-rr-angle-small-left"></i> Edit Admin
                                    </div>
                                }

                                
                                {title_dashboard.replace(/\/[A-Za-z0-9+/=]+$/, "") == '/admin/list-user/edit-user' && 
                                    <div onClick={()=>handleBack()} style={{cursor:'pointer'}}>
                                        <i class="fi fi-rr-angle-small-left"></i> Edit User
                                    </div>
                                }

                                {title_dashboard == '/admin/list-user' && 'List User'}
                                {title_dashboard == '/admin/list-user/add-user/' && 
                                    <div onClick={()=>handleBack()} style={{cursor:'pointer'}}>
                                        <i class="fi fi-rr-angle-small-left"></i> Create User
                                    </div>
                                }
                                {title_dashboard == '/admin/list-plts' && 'List PLTS'}
                                {title_dashboard == '/admin/list-plts/add-plts' && 
                                    <div onClick={()=>handleBack()} style={{cursor:'pointer'}}>
                                        <i class="fi fi-rr-angle-small-left"></i> Create PLTS
                                    </div>
                                }
                                {title_dashboard == '/admin/mapping-list' && 'Mapping List'}  
                                </h2>
                            </div>
                            <div className='col-md-3'>
                                <label className={css.profile}>Edo Bagaskoro</label>
                                <div className={css.square}>E</div>
                            </div>
                        </div>
                    </div>
                    <Outlet />
                </div>
            </div>
        </div>
    );
}

export default LayoutAdmin;